import { GsFormControl, GsFormField } from 'libs/shared/src/components';

export const BASIC_SCHEMA_FIELDS: GsFormField<never>[] = [
  {
    formControlName: 'clientId',
    type: 'control'
  } as GsFormControl<never>,
  {
    formControlName: 'maxWidth',
    type: 'number',
    label: 'schema.component.maxWidth.name',
    description: 'schema.component.maxWidth.description',
    isResponsive: true,
    placeholder: 'schema.component.maxWidth.fullWidth',
    nullable: true
  },
  {
    formControlName: 'anchor',
    type: 'text',
    label: 'schema.component.anchor.name',
    description: 'schema.component.anchor.description',
    placeholder: 'schema.component.anchor.placeholder',
    nullable: true
  },
  {
    formControlName: 'maxCacheHours',
    type: 'number',
    label: 'schema.component.maxCacheHours.name',
    description: 'schema.component.maxCacheHours.description',
    // Backend "content" tab; dialogs without it fall back to "appearance".
    tabName: 'content',
    nullable: true,
    min: 0,
    step: 0.5
  }
];
